import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Spin } from 'antd';
import PageLoader from '../../../../components/PageLoader/PageLoader';
import OrganisationMainSection from '../../../../components/OrganisationMainSection/OrganisationMainSection';
import StrategicThirdPartyActionBar from './components/StrategicThirdPartyActionBar';
import StrategicThirdPartyClass from './components/StrategicThirdPartyClass';
import * as actions from './StrategicThirdPartyAction';
import { orgIdSelector } from '../../OrganisationSelectors';
import {
  strategicThirdPartyListSelector,
  strategicThirdPartyCategoriesSelector,
  loadingStrategicThirdPartySelector
} from './StrategicThirdPartySelectors';

const CLASS_NAME = 'Strategic Crisis Experts';

const TOOLTIP_DETAIL = (
  <p>Strategic Crisis Experts are external organisations that may be required following an event.</p>
);

const GUIDANCE = (
  <>
    <strong>What to do:</strong> keep the experts who matter to your continuity response, remove the rest, and use{' '}
    <strong>Import</strong> or <strong>Add new</strong> to fill gaps.
  </>
);

const StrategicCrisisExpert = ({
  orgId,
  loading,
  strategicThirdPartyList,
  strategicThirdPartyCategories,
  fetchStrategicThirdPartyCategories,
  fetchStrategicThirdParty
}) => {
  useEffect(() => {
    fetchStrategicThirdPartyCategories();
    fetchStrategicThirdParty(orgId);
  }, [orgId, fetchStrategicThirdPartyCategories, fetchStrategicThirdParty]);

  const cats = strategicThirdPartyCategories && strategicThirdPartyCategories[CLASS_NAME];
  const rows = strategicThirdPartyList && strategicThirdPartyList[CLASS_NAME];

  return strategicThirdPartyList && strategicThirdPartyCategories ? (
    <OrganisationMainSection
      title="Strategic Crisis Experts"
      tooltipContent={TOOLTIP_DETAIL}
      guidance={GUIDANCE}
      toolbarActions={
        cats ? (
          <StrategicThirdPartyActionBar strategicThirdPartyClass={CLASS_NAME} strategicThirdPartyCategories={cats} />
        ) : null
      }
      flowPrev="/organization/strategic-third-parties"
      flowNext="/organization/strategic-areas"
    >
      <Spin spinning={loading}>
        <StrategicThirdPartyClass
          surfaceOnly
          strategicThirdPartyList={rows}
          strategicThirdPartyClass={CLASS_NAME}
          strategicThirdPartyCategories={cats}
        />
      </Spin>
    </OrganisationMainSection>
  ) : (
    <PageLoader tip="Loading Strategic Crisis Experts..." />
  );
};

const mapStateToProps = state => ({
  orgId: orgIdSelector(state),
  strategicThirdPartyList: strategicThirdPartyListSelector(state),
  strategicThirdPartyCategories: strategicThirdPartyCategoriesSelector(state),
  loading: loadingStrategicThirdPartySelector(state)
});

const mapDispatchToProps = { ...actions };

export default connect(mapStateToProps, mapDispatchToProps)(StrategicCrisisExpert);
